const $ = require('jquery');
require('fg-frontend/third/jquery.cookie');
let _ = require('lodash');

'use strict';

const PLUGIN_NAME = 'webGtmHandler';

const DEFAULTS = { 
  debug: false, // v debug rezimu se data neodesilaji, jen se zobrazuji v konzoli
  ajaxLoad: false, // identifikace, zda je inicializace pluginu standardni nebo na zaklade dokonceneho ajax pozadavku
  gtmPageData: {}, // data stránky publikované při načtení stránky
  leadIdCookie: 'fg_gtm_lead_id',	// název cookie ve které se nachází hodnota Lead ID
  fragments: {
    FG_NEWS_DETAIL: '[data-fragment="wg.news.detail"]',
    FG_EVENT_DETAIL: '[data-fragment="wg.event.detail"]',
    FG_LEADID_FORM: '[data-fragment="wg.leadid.form"]',
    FG_LEADID_INPUT: '[data-fragment="wg.leadid.input"]',
    FG_RESULTS_ELEMENT: '[data-fragment="wg.result.ele"]',
    FG_BANNERS_ELEMENT: '[data-fragment="wg.banner"]',
    FG_BANNERS_LINK: '[data-fragment="wg.banner.link"]',
  },
};

/**
 * plugin constructor
 * @param element
 * @param options
 * @constructor
 */
function WebGtmHandler(element, options) {
  this.element = element;
  this.$body = $(this.element);

  this.options = $.extend(true, {}, DEFAULTS, options);

  this._defaults = DEFAULTS;
  this._name = PLUGIN_NAME;


  this.bindData = {};

  this.ajaxBinded = [];

  this.initialise();
}

/**
 * inicializace
 */
WebGtmHandler.prototype.initialise = function () {
  const self = this;

  this.logger_('Debug režim - data, která příjdou z vypublikované stránky', this.options.gtmPageData);

  this.$leadId = null;

  this.$newsDetail = $(this.options.fragments.FG_NEWS_DETAIL);
  this.$eventDetail = $(this.options.fragments.FG_EVENT_DETAIL);
  this.$leadIdForms = $(this.options.fragments.FG_LEADID_FORM);
  this.$banners = $(this.options.fragments.FG_BANNERS_ELEMENT);

  self.getLeadId_();
  this.logger_('Debug režim - aktuální Lead ID uživatele', self.getCookie_(this.options.leadIdCookie));

  self.bindEvents();

  self.onPageLoad_();
};

/**
 * nabindovani udalosti
 */
WebGtmHandler.prototype.bindEvents = function () {
  const self = this;

  // po výměně obsahu PU načte data object ze kterého vytvoří push do DL
  $(document).on('afterContentsReplaced', (e) => {
    self.afterContentsReplaced(e);
  });

  // ve vybraných formech nastaví leadId
  if (this.$leadIdForms instanceof $) {
    self.setLeadId_(this.$leadIdForms);
  }

  // bannery na stránce
  if (this.$banners instanceof $) {
    self.loadBanners_(this.$banners);
  }
};

/**
 * Provede akci po výměně obsahu pomocí PU
 * @info Pokusí se najít prvek obsahující nasetovaná data ze kterých by mohl sestavit push. Pokud najde tak podle atributu push pustí příslušnou akci.
 * @param event
 */
WebGtmHandler.prototype.afterContentsReplaced = function (event) {
  let self = this,
    o = this.options,
    $data = {},
    $r = $(o.fragments.FG_RESULTS_ELEMENT, $(event.target));

  self.logger_('Debug režim - afterContentsReplaced', $r, $(event.target));

  if ($r.length > 0) {
    $data = $r.data('wgtm');
    if (typeof ($data.type) !== 'undefined') {
      switch ($data.type) {
        case 'brigade_registration':
          self.onBrigadeRegistration_($data);
          break;
        case 'lead':
          self.onLeadSend_($data);
          break;
        case 'leadRedirect':
          self.onLeadRedirectSend_($data);
          break;
        case 'newsletter':
          self.onNewsletterSend_($data);
          break;
        default:
          break;
      }
    }
  }
};

/**
 * Provedení akcí po načtení bannerů
 *
 * @param banners
 * @private
 */
WebGtmHandler.prototype.loadBanners_ = function (banners) {
  let self = this,
    o = this.options;

  if (banners.length > 0) {
    self.onViewBanners_(banners);
    banners.each(function () {
      let $t = $(this),
        $data = $t.data('wgtm');
      self.onLoadBanner_($data, $t);
      self.onClickBanner_($data, $t);
    });
  }
};

/**
 * Odesle data do GTM nebo je zobrazi v konzoli
 * @param data
 */
WebGtmHandler.prototype.sendDataToGTM = function (data) {
  let self = this,
    dataLayer = window.dataLayer || [];

  if (typeof (data) !== 'undefined') {
    if (self.options.debug) {
      self.logger_('Debug rezim - data, ktera by se odeslala do GTM:', data);
    }
    // push dataLayer
    else {
      dataLayer.push(data);
    }
  }
};

/**
 * Provede vystřelení eventu po načtení stránky
 *
 * @private
 */
WebGtmHandler.prototype.onPageLoad_ = function () {
  let self = this,
    o = this.options;

  document.addEventListener('DOMContentLoaded', () => {
    self.sendDataToGTM({
      event: 'page_view',
      user_data: self.getDataUserData(),
      environment: o.gtmPageData.projectEnvironment,
      site: self.getDataSite(o.gtmPageData.webSystemId),
      page_data: self.getDataPageData(o.gtmPageData.webPage),
    });
  });
};

/**
 * Vystřelí event po kliknutí na banner
 *
 * @desc 'banner_dimensions' Velikost banneru - 300x250
 * @desc 'banner_id' ID zobrazeného banneru - b-382-ab-43 // todo: touto hodnotou nemáme
 * @desc 'banner_type' Typ zobrazeného banneru - html5 | static | gif // todo: posíláme gif nebo static
 * @desc 'banner_name' Jméno obrázku banneru - banner.jpg
 * @desc 'banner_sale_type' Způsob prodeje bannerové plochy - rtb | direct | programmatic_guaranteed | header_bidding // todo: touto hodnotou nemáme
 * @desc 'click_url' URL prokliku z banneru
 *
 * @param dSet
 * @param banner
 * @private
 */
WebGtmHandler.prototype.onClickBanner_ = function (dSet, banner) {
  let self = this,
    o = this.options,
    $l = $(o.fragments.FG_BANNERS_LINK, banner),
    data = {};

  if ($l.length > 0) {
    $l.on('click', function () {
      self.logger_('Debug režim - onClickBanner_', dSet, $(this));

      self.sendDataToGTM({
        event: 'banner~click',
        user_data: self.getDataUserData(),
        banner_dimensions: dSet.dimensions,
        banner_id: dSet.id,
        banner_type: dSet.type,
        banner_name: dSet.name,
        banner_sale_type: dSet.saleType,
        click_url: dSet.clickUrl,
      });
    });
  }
};

/**
 * Vystřelí event po zobrazení aspoň 50% banneru po dobu 1 s.
 *
 * @desc 'banner_dimensions' Velikost banneru - 300x250
 * @desc 'banner_id' ID zobrazeného banneru - b-382-ab-43 // todo: touto hodnotou nemáme
 * @desc 'banner_type' Typ zobrazeného banneru - html5 | static | gif // todo: posíláme gif nebo static
 * @desc 'banner_name' Jméno obrázku banneru - banner.jpg
 * @desc 'banner_sale_type' Způsob prodeje bannerové plochy - rtb | direct | programmatic_guaranteed | header_bidding // todo: touto hodnotou nemáme
 * @desc 'click_url' URL prokliku z banneru
 *
 * @param dSet
 * @param banner
 * @private
 */
WebGtmHandler.prototype.onViewBanners_ = function (banners) {
  let self = this,
    o = this.options,
    $b = banners;

  if ($b.length > 0) {

    $(window).on("scroll", _.debounce(
      function () {

        $b.each(function () {
          let $l = $(this),
              dSet = $l.data('wgtm'),
              $lbi = $l.data('myfragment');

              self.logger_('Debug režim - onViewBanner_', dSet, $l);

              if ($lbi === 'Leaderboard.item') {
                if ($l.hasClass('active')) {
                  if (!$l.hasClass('banner-viewable')) {
                    if(self.isElementInView_($l)) {
                      // element je vidět, odpočítáme 1s. a provedeme nové ověření
                      setTimeout(() => {
                        if(self.isElementInView_($l)) {
                          $l.addClass('banner-viewable');
                          self.sendDataToGTM({
                            event: 'banner~impression_viewable',
                            user_data: self.getDataUserData(),
                            banner_dimensions: dSet.dimensions,
                            banner_id: dSet.id,
                            banner_type: dSet.type,
                            banner_name: dSet.name,
                            banner_sale_type: dSet.saleType,
                          });
                        }
                      }, 1000);
                    }
                  } else {
                    // pokud již byl zobrazen, testneme zda je pořád ještě vidět a pokud ne tak odebereme classu
                    if(!self.isElementInView_($l)) {
                      $l.removeClass('banner-viewable');
                    }
                  }
                }
              } else {
                if (!$l.hasClass('banner-viewable')) {
                  if(self.isElementInView_($l)) {
                      // element je vidět, odpočítáme 1s. a provedeme nové ověření
                      setTimeout(() => {
                        if(self.isElementInView_($l)) {
                          $l.addClass('banner-viewable');
                          self.sendDataToGTM({
                            event: 'banner~impression_viewable',
                            user_data: self.getDataUserData(),
                            banner_dimensions: dSet.dimensions,
                            banner_id: dSet.id,
                            banner_type: dSet.type,
                            banner_name: dSet.name,
                            banner_sale_type: dSet.saleType,
                          });
                        }
                      }, 1000);
                  }
                } else {
                  // pokud již byl zobrazen, testneme zda je pořád ještě vidět a pokud ne tak odebereme classu
                  if(!self.isElementInView_($l)) {
                    $l.removeClass('banner-viewable');
                  }
                }
              }
       });
     }, 333));
  }
};

/**
 * Vystřelí event po načtení banneru
 *
 * @desc parametry stejné jako u kliku na banner akorát, že zde chybí URL po kliknutí
 *
 * @param dSet
 * @param banner
 * @private
 */
WebGtmHandler.prototype.onLoadBanner_ = function (dSet, banner) {
  const self = this;
  let $l = banner,
    $lbi = $l.data('myfragment');

  self.logger_('Debug režim - onLoadBanner_', dSet, $l, $lbi);

  if ($lbi === 'Leaderboard.item') {
	  $l.on('onLoadBanner', function () {
		  if ($(this).hasClass('active')) {
			  self.sendDataToGTM({
				  event: 'banner~impression',
				  user_data: self.getDataUserData(),
				  banner_dimensions: dSet.dimensions,
				  banner_id: dSet.id,
				  banner_type: dSet.type,
				  banner_name: dSet.name,
				  banner_sale_type: dSet.saleType,
			  });
		  }
	  });
  } else {
    self.sendDataToGTM({
      event: 'banner~impression',
      user_data: self.getDataUserData(),
      banner_dimensions: dSet.dimensions,
      banner_id: dSet.id,
      banner_type: dSet.type,
      banner_name: dSet.name,
      banner_sale_type: dSet.saleType,
    });
  }
};

/**
 * Provede vystřelení eventu po odeslání přihlášení k newsletteru
 * @param dSet
 * @private
 */
WebGtmHandler.prototype.onNewsletterSend_ = function (dSet) {
  let self = this,
    o = this.options;

  self.sendDataToGTM({
    event: 'form~submit',
    user_data: self.getDataUserData(),
    form_data: {
      form_email: dSet.email,
      form_fire_brigade: dSet.brigade,
      form_type: dSet.type,
    },
    lead_id: dSet.leadId,
  });
};

/**
 * Provede vystřelení eventu po odeslání Leadového formuláře
 * @param dSet
 * @private
 */
WebGtmHandler.prototype.onLeadSend_ = function (dSet) {
  let self = this,
    o = this.options;

  self.sendDataToGTM({
    event: 'form~submit',
    user_data: self.getDataUserData(),
    form_data: {
      form_name: dSet.name,
      form_surname: dSet.surname,
      form_email: dSet.email,
      form_phone: self.formatPhone_(dSet.phone),
      form_fire_brigade: dSet.brigade,
      form_type: dSet.type,
    },
    lead_id: dSet.leadId,
  });
};

/**
 * Provede vystřelení eventu po odeslání Leadového formuláře a provede přesměrování na požadovanou URL
 * @param dSet
 * @private
 */
WebGtmHandler.prototype.onLeadRedirectSend_ = function (dSet) {
  let self = this,
    o = this.options;

  self.sendDataToGTM({
    event: 'form~submit',
    user_data: self.getDataUserData(),
    form_data: {
      form_name: dSet.name,
      form_surname: dSet.surname,
      form_email: dSet.email,
      form_phone: self.formatPhone_(dSet.phone),
      form_fire_brigade: dSet.brigade,
      form_type: dSet.type,
    },
    lead_id: dSet.leadId,
  });

  if (dSet.urlRedirect) {
    window.location.replace(dSet.urlRedirect);
  }
};

/**
 * Provede vystřelení eventu po odeslání Chci web zdarma
 *
 * @desc 'form_name' Křestní jméno zadané do formuláře
 * @desc 'form_surname' Příjmení zadané do formuláře
 * @desc 'form_email' E-mail zadaný do formuláře
 * @desc 'form_phone' Telefon zadaný do formuláře
 * @desc 'form_region' Kraj
 * @desc 'form_county' Okres
 * @desc 'form_fire_brigade' Hasičský sbor
 * @desc 'form_type' string - brigade_registration | lead | newsletter
 *
 * @param dSet
 * @private
 */
WebGtmHandler.prototype.onBrigadeRegistration_ = function (dSet) {
  let self = this,
    o = this.options,
    data = {};

  self.sendDataToGTM({
    event: 'form~submit',
    user_data: self.getDataUserData(),
    form_data: {
      form_name: dSet.name,
      form_surname: dSet.surname,
      form_email: dSet.email,
      form_phone: self.formatPhone_(dSet.phone),
      form_region: dSet.region,
      form_county: dSet.county,
      form_fire_brigade: dSet.brigade,
      form_type: dSet.type,
    },
    lead_id: dSet.leadId,
  });
};

/**
 * metoda pro sestavení dat do proměné dataLayeru PAGE_DATA
 *
 * @Desc 'page_category' Kategorie stránek - string - hodnoty:
 * 		Zobrazení kategorie - category_view - nastaveno na novinkách a kalendáři + rozeskokové stránky
 * 		Detail článku - article_detail - nastaveno na detailu novinky
 * 		Detail akce - event_detail - nastaveno na detailu akce
 * 		Produktové stránky - product_detail - detailu produktu v e-shopu todo: to je e-shop zatím nenastaveno
 * 		Výsledky vyhledávání - search_results - nastaveno na výsledcích vyhledávání
 * 		Langing page (pokud budou existovat) - landing_page - todo: tady nevím co tím myslí, co je landing page na hasičovu? a je tam nějaká?
 * 		Lead magnety (stránky zapadající do větve Výhody) - lead_magnets - nastaveno na stránky ze sekce Výhody na webu hasičovo (na MS není), jedná se o stránky s prototypy pgProductPage, pgInsurance, pgBankAccount a pgTravelInsurance
 *
 * @Desc 'post_category' Kategorie článku; vhodné pro sekce, kde jsou detaily článků - string - cela_CR | obecne
 * @Info Vkládá se název tagu ze sekcí NEWS a EVENTS (akce, dotace, zásahy apod.)
 * @Desc 'page_location' Celá URL adresa včetně protokolu - string - https://www.hasicovo.cz/cs/zpravy/predstavujeme-jednotky-z-oblasti-vychod-cech-nominovane-v-ankete-dobrovolni-hasici-roku
 * @Desc 'page_language' Jazyk, ve kterém se web zobrazuje uživateli - string - en | cz | de
 * @Desc 'date_published' Datum publikace stránky ve formátu YYYY-MM-DD - string - 2021-03-09
 * @Desc 'date_last_modified' Datum poslední změny na stránce ve formátu YYYY-MM-DD - string - 2021-04-15
 * @Desc 'author_name' Jméno autora stránky - string - Matěj Prošek
 * @Desc 'article_location' Lokalita, ve které se nachází hlavní dějiště článku - string - Celá ČR | Jihomoravský
 * @Info Vkládá se název tagu ze sekce REGIONS (Jihomoravský kraj, Královehradecký)
 *
 * @param d
 * @returns {{page_category: string, post_category: *, page_location: *, page_language: *, date_published: *, date_last_modified: *, author_name: *, article_location: *}}
 */
WebGtmHandler.prototype.getDataPageData = function (d) {
  let self = this,
    o = this.options,
    resultPageCategory = 'undefined';
  const pageCategory = [
    'category_view',
    'article_detail',
    'event_detail',
    'product_detail',
    'search_results',
    'landing_page',
    'lead_magnets',
  ];

  switch (d.prototype) {
    case 'listNews':
    case 'listKSHNews':
    case 'listOSHNews':
    case 'listHSNews':
      if (self.$newsDetail.length > 0) {
        resultPageCategory = pageCategory[1];
      } else {
        resultPageCategory = pageCategory[0];
      }
      break;
    case 'listEvents':
    case 'listKSHEvents':
    case 'listOSHEvents':
    case 'listHSEvents':
      if (self.$eventDetail.length > 0) {
        resultPageCategory = pageCategory[2];
      } else {
        resultPageCategory = pageCategory[0];
      }
      break;
    case 'fulltext':
      resultPageCategory = pageCategory[4];
      break;
    case 'pgIndex':
      resultPageCategory = pageCategory[0];
      break;
    case 'pgProductPage':
    case 'pgInsurance':
    case 'pgBankAccount':
    case 'pgTravelInsurance':
      resultPageCategory = pageCategory[6];
      break;
    default:
      resultPageCategory = 'undefined';
      break;
  }

  return {
    page_category: resultPageCategory,
    post_category: d.postCategory.tagName,
    page_location: d.url,
    page_language: d.lang,
    date_published: d.created,
    date_last_modified: d.modified,
    author_name: d.author,
    article_location: d.articleLocation.tagName,
  };
};

/**
 * metoda pro sestavení dat do proměné dataLayeru USER_DATA
 *
 * @Desc 'user_id' ID uživatele v hlavní databázi - string - abc123
 * @Desc 'user_segment' Segment, do kterého spadá uživatel v Exponee nebo interní segmentační databázi - string - likely_to_convert | purchasers todo: tady vůbec netuším jestli nějaká segmentace uživatelů v e-shopu je
 * @Desc 'user_state' Stav uživatele - string - logged_in | logged_out
 * @Desc 'user_ltv' Celková hodnota všech nakoupených produktů a dobitého kreditu od vzniku uživatelského účtu - float - 1232.11
 * @Desc 'user_points' Počet bodů, které uživatel nashromáždil - integer - 12
 * @Desc 'user_brigade_id' ID sboru, ke kterému tento uživatel patří - string - sdh001 todo: tady bych to odhadoval na webId...
 * @Desc 'user_brigade_points' Počet bodů, které nashromáždil celý sbor, jehož je uživatel členem - integer - 38
 * @Desc 'user_consent_level' Úroveň marketingového souhlasu uživatele - string - ad_storage | analytics_storage | functionality_storage | personalization_storage | security_storage
 *
 * @returns {{user_id: undefined, user_segment: undefined, user_state: undefined, user_ltv: undefined, user_points: undefined, user_brigade_id: undefined, user_brigade_points: undefined, user_consent_level: string}}
 */
WebGtmHandler.prototype.getDataUserData = function () {
  let self = this,
    o = this.options;
  const cookieLevelName = [
    'config',	// uzivatel videl panel a chce nastavit uroven
    'technical', // uz. souhlasi s technickymi cookies (min uroven po ulozeni nastaveni)
    'analytics', // uz. souhlasi s technickymi A analytickymi cookies (nepouzito)
    'marketing',	// uz. souhlasi s technickymi A analytickymi A marketingovymi cookies
  ];

  return {
    user_id: undefined,
    user_segment: undefined,
    user_state: undefined,
    user_ltv: undefined,
    user_points: undefined,
    user_brigade_id: undefined,
    user_brigade_points: undefined,
    user_consent_level: cookieLevelName[(parseInt(self.getCookie_('fg_cookie_policy_accepted')) - 1)],
  };
};

/**
 * metoda pro sestavení dat do proměné dataLayeru SITE
 *
 * @Desc Stránka, kde se uživatel nachází. Odlišujte jednotlivé microsites i subdomény - string - microsite~ksh_cms_usti | eshop | pozarni_sport | microsite~osh_cms_usti
 *
 * @Info Proměnou setavujeme podle systémového ID webu, které je následně převedeno na malá písmena. přidáváme prefix microsite~ pokud se nejedná o hlavní web, e-shop nebo šablonu.
 *
 * @param d
 * @returns {*}
 */
WebGtmHandler.prototype.getDataSite = function (d) {
  let self = this,
    o = this.options,
    msPrefix = 'microsite~';
  const excludePrefixId = [
    'ROOT',
    'ESHOPHASICOVO-ROOT',
    'TMPL_KSH',
    'TMPL_OSH',
    'TMPL_HS',
  ];

  if ((excludePrefixId.indexOf(d) != -1)) {
    // isMicrosite = false;
    switch (d) {
      case 'ROOT':
        d = 'hasicovo';
        break;
      case 'ESHOPHASICOVO-ROOT':
        d = 'eshop';
        break;
      default:
        d = d.toLowerCase();
        break;
    }
  } else {
    // isMicrosite = true;
    d = msPrefix + d.toLowerCase();
  }

  return d;
};

/**
 * Uzivatelska metoda: doplni aktualni url do dat
 * @param data: vychozi data objektu
 * @returns {*}
 */
WebGtmHandler.prototype.customSetUrl = function (data) {
  const url = encodeURI(window.location.href);

  if (data) {
    data.fgAct = url;
  }

  return data;
};

/**
 * Calculate what is or isn’t visible
 *
 * @param element
 * @private
 */
WebGtmHandler.prototype.isElementInView_ = function (element) {
  let self = this,
    o = this.options;

    // var elementBoundingBox = element.getBoundingClientRect();
    let elementBoundingBox = element.get(0).getBoundingClientRect();
    let elementTopY = elementBoundingBox.top;
    let elementBottomY = elementBoundingBox.top + (elementBoundingBox.height / 2);
    return elementTopY >= 0 && elementBottomY <= Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
};

/**
 * Nasetuje Lead ID do polí ve formulářích
 *
 * @param leadForms
 * @private
 */
WebGtmHandler.prototype.setLeadId_ = function (leadForms) {
  let self = this,
    o = this.options;
  self.$leadId = self.getCookie_(o.leadIdCookie);

  if (leadForms.length > 0) {
    leadForms.each(function () {
      let $t = $(this),
        $i = $(o.fragments.FG_LEADID_INPUT, $t);
      $i.val(self.$leadId);
    });
  }
};

/**
 * Obsluha Lead Id
 *
 * @info Při přístupu uživatele na web se zkontroluje zda existuje Lead ID a pokud ne tak ho vygenerujeme a uložíme do cookie s platností na 10 let.
 * @returns {Number}
 * @private
 */
WebGtmHandler.prototype.getLeadId_ = function () {
  let self = this,
    o = this.options;
  self.$leadId = self.getCookie_(o.leadIdCookie);

  if (self.$leadId === null) {
    self.$leadId = self.genLeadId_();
    self.setCookie_(self.$leadId, o.leadIdCookie, 3650, '/');
  }
};

/**
 * Generování Lead ID
 *
 * @info ID se skládá ze tří částí, první část je prefix 'lead' ve druhé části je 6 číslic z aktuálního timestampu a ve třetí části se generuje náhodný řetězec o délce 4 znaků
 * @returns {string}
 * @private
 */
WebGtmHandler.prototype.genLeadId_ = function () {
  const timeNow = (new Date()).getTime().toString();
  return `lead-${timeNow.substr(-6)}-${Math.random().toString(36).substr(2, 4)}`;
};

/**
 * Uložení hodnoty do cookies
 *
 * @param val
 * @param cookieName
 * @param exp
 * @param path
 * @private
 */
WebGtmHandler.prototype.setCookie_ = function (val, cookieName, exp, path) {
  var secure = this.isSecure_(),
    path = { path },
    exp = { expires: exp };
  $.cookie(cookieName, val, $.extend(true, {}, path, exp, secure));
};

/**
 * Získání hodnoty cookies
 * @param cookie
 * @returns {String|*}
 * @private
 */
WebGtmHandler.prototype.getCookie_ = function (cookie) {
  return $.cookie(cookie);
};

/**
 * Test is protocol Secure
 * @returns {*}
 * @private
 */
WebGtmHandler.prototype.isSecure_ = function () {
  return location.protocol === 'https:' ? { secure: 'true' } : {};
};

/**
 * Přidá poředvolbu státu pokud číslo nezačíná + nebo 00
 * @returns {*}
 * @private
 */
WebGtmHandler.prototype.formatPhone_ = function (number) {
  number = `${number.replace(/ /g, '')}`;
  if (number.substring(0, 1) !== '+') {
    number = `+420${number}`;
  }
  return number;
};

/**
 * simple logger
 */
WebGtmHandler.prototype.logger_ = function (...args: any) {
  if (window.console && this.options.debug) {
    console.group('Debug of GtmHandler');
    Object.values(args).forEach(value => console.log(value));
    console.groupEnd();
  }
};

/**
 * decide, which methods will be "public"
 *  $(JQ_object).PLUGIN_NAME( 'action', { param:"value" } );
 */
const API = {
  // banners: WebGtmHandler.prototype.isSecure_(),
};


/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;


  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new WebGtmHandler(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/jquery.webGtmHandler.js